type WarningTriangleOutlineIconProps = {
  size?: number;
  color?: string;
};

const WarningTriangleOutlineIcon = ({
  size = 18,
  color = '#131313',
}: WarningTriangleOutlineIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g>
      <path
        d="M8.9996 0.0078125C9.35454 0.0078125 9.7031 0.106132 10.0059 0.29126C10.2707 0.453192 10.4924 0.675822 10.6519 0.940552L10.7168 1.05701L10.719 1.0625L17.7898 15.203L17.8864 15.4293C17.9408 15.5831 17.9746 15.7435 17.9886 15.9061L17.9941 16.1522C17.9804 16.4809 17.8834 16.8007 17.7118 17.0806C17.5827 17.2906 17.4143 17.4738 17.2174 17.62L17.0119 17.7529C16.7254 17.9139 16.4024 17.9991 16.0737 18.0001H1.9266C1.67994 17.9994 1.43643 17.9514 1.20919 17.8595L0.988369 17.7529C0.701572 17.592 0.460476 17.3607 0.288539 17.0806C0.116614 16.8004 0.0188543 16.4807 0.0050921 16.1522C-0.00866233 15.8237 0.062559 15.4966 0.210536 15.203L7.28024 1.0625L7.28354 1.05701C7.44537 0.74109 7.69153 0.476377 7.99435 0.29126C8.2971 0.106191 8.64477 0.00787742 8.9996 0.0078125ZM8.9996 1.29321C8.8814 1.29328 8.76536 1.32605 8.66452 1.3877C8.5638 1.44929 8.48223 1.5376 8.42831 1.64258L1.35971 15.7809L1.35861 15.782C1.30933 15.8798 1.2859 15.9888 1.29049 16.0984L1.29928 16.1797C1.31304 16.2601 1.34195 16.3381 1.38498 16.4082C1.4423 16.5014 1.52272 16.5789 1.61789 16.6323C1.7132 16.6858 1.82066 16.7143 1.9299 16.7147H16.0693C16.1789 16.7144 16.287 16.686 16.3824 16.6323C16.4777 16.5789 16.5579 16.5006 16.6153 16.4071C16.6725 16.3136 16.7053 16.2074 16.7098 16.0984L16.7076 16.016C16.7006 15.9349 16.6786 15.8553 16.6417 15.782L16.6406 15.7809L9.57199 1.64258C9.51804 1.53749 9.43549 1.44932 9.33468 1.3877C9.23384 1.32615 9.11775 1.29321 8.9996 1.29321Z"
        fill={color}
      />
      <path
        d="M8.35746 10.6069V6.42882C8.35746 6.07378 8.64512 5.78612 9.00016 5.78612C9.3552 5.78612 9.64286 6.07378 9.64286 6.42882V10.6069C9.64286 10.962 9.3552 11.2507 9.00016 11.2507C8.64512 11.2507 8.35746 10.962 8.35746 10.6069Z"
        fill={color}
      />
      <path
        d="M9.00097 12.8575C9.3558 12.8577 9.64367 13.1453 9.64367 13.5002C9.64367 13.6177 9.6087 13.7261 9.55359 13.821C9.60902 13.9159 9.64365 14.025 9.64367 14.1429C9.64367 14.4977 9.3558 14.7853 9.00097 14.7856C8.50161 14.7856 8.08997 14.4063 8.04077 13.9198L8.03637 13.8221L8.04077 13.7232C8.09004 13.2368 8.50166 12.8575 9.00097 12.8575Z"
        fill={color}
      />
      <path
        d="M9.96509 13.8221C9.96484 14.3545 9.53333 14.7856 9.00097 14.7856C8.64593 14.7856 8.35779 14.4979 8.35779 14.1429C8.35782 14.0249 8.39237 13.916 8.44788 13.821C8.39269 13.7261 8.35779 13.6179 8.35779 13.5002C8.35779 13.1452 8.64593 12.8575 9.00097 12.8575C9.53348 12.8575 9.96509 13.2894 9.96509 13.8221Z"
        fill={color}
      />
    </g>
  </svg>
);

export default WarningTriangleOutlineIcon;
